var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anim-box-root"},[_c('div',{ref:"box",staticClass:"box",style:(_vm.boxStyle),on:{"click":_vm.fireAction,"animationend":_vm.endAnimation}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }